import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import InputText from "../../../components/Forms/Element/InputText";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import ModuleAccessSelector from "../../../components/Custom/Identity/Permisson/ModuleAccessSelector";
import axiosInstance from "../../../../services/AxiosInstance";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import FormSection from "../../../components/Common/Form/FormSection";
import { MENU_ITEMS_BY_MODULE } from "../../../components/Custom/Identity/Permisson/ModuleAccessSelector";

const Form = (props) => {
    const { t } = useTranslation();
    const {
        status, setStatus, formik, entityData,
        setSelectedPermissions, setSelectedMenuPermissions, reset
    } = props;
    const [initialPermissions, setInitialPermissions] = useState([]);
    const [initialMenuPermissions, setInitialMenuPermissions] = useState([]);

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('name', entityData.name);
            setStatus(convertStatusToBoolean(entityData.status));

            Promise.all([
                axiosInstance.get(`${Api.identity.group_permission}/group/${entityData.id}`),
                axiosInstance.get(`${Api.identity.group_menu_permission}/group/${entityData.id}`)
            ])
            .then(([permissionResponse, menuPermissionResponse]) => {
                const permissions = (permissionResponse.data || []).map(item => item.permission);
                const menuPermissions = menuPermissionResponse.data || [];

                // Grupos gravados antes da seleção automática podem ter módulo sem
                // nenhum submenu, o que oculta o módulo inteiro na navegação.
                const normalizedMenuPermissions = permissions.flatMap(permission => {
                    const hasSavedMenus = menuPermissions.some(item => item.permission === permission);
                    if (hasSavedMenus) return [];
                    return (MENU_ITEMS_BY_MODULE[permission] || []).map(item => ({
                        permission,
                        menuKey: item.menuKey
                    }));
                });

                setInitialPermissions(permissions);
                setInitialMenuPermissions([...menuPermissions, ...normalizedMenuPermissions]);
            })
            .catch(error => ApiError(error));
        } else {
            setInitialPermissions([]);
            setInitialMenuPermissions([]);
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('group_basic_information_hint')}
                    icon="fa-solid fa-users"
                >

                    <Row className="g-3">
                        <Col md={6} xl={5}>
                            <FormGroup>
                                <FormLabel>{t('name')} <AsteriskRequired /></FormLabel>
                                <InputText
                                    name="name"
                                    placeholder={t('group_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                    maxlength="50"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('permissions')}
                    description={t('group_permissions_hint')}
                    icon="fa-solid fa-shield-halved"
                >

                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <ModuleAccessSelector
                                    setSelectedPermissions={setSelectedPermissions}
                                    setSelectedMenuPermissions={setSelectedMenuPermissions}
                                    initialPermissions={initialPermissions}
                                    initialMenuPermissions={initialMenuPermissions}
                                    reset={!reset}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('status')}
                    description={t('group_status_hint')}
                    icon="fa-solid fa-toggle-on"
                    compact
                >

                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
